var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notice-bar',{attrs:{"mode":_vm.$$FormData.closeable ? 'closeable' : '',"left-icon":"volume","text":_vm.$$FormData.content || _vm.default_notice,"background":_vm.$$FormData.background_color,"color":_vm.$$FormData.content_color}})
}
var staticRenderFns = []

export { render, staticRenderFns }